// Module
var code = `<div class="deck-flywheel">
  {{#artImage}}
  <img class="deck-flywheel-arrows" src="{{attrImageSrc}}" alt="" />
  {{/artImage}}
  {{#artPlaceholder}}
  <div class="deck-placeholder deck-flywheel-arrows">
    <span class="deck-placeholder-label">{{fileName}}</span>
  </div>
  {{/artPlaceholder}}
  <ol class="deck-flywheel-arcs">
    {{#listItems}}
    <li class="deck-flywheel-arc deck-flywheel-arc--{{attrPosition}} deck-flywheel-arc--{{attrStatus}}">
      <svg class="deck-flywheel-art" viewBox="0 0 400 300" aria-hidden="true">
        <path class="deck-flywheel-leader" d="{{attrLeaderPath}}" />
        <circle class="deck-flywheel-dot" cx="{{attrDotX}}" cy="{{attrDotY}}" r="2.5" />
      </svg>
      <p class="deck-flywheel-label">{{copy}}</p>
    </li>
    {{/listItems}}
  </ol>
</div>
`;
// Exports
module.exports = code;